import { createContext, useContext } from 'react';

export interface CaseContextType {
  refetchCase: () => void;
}

export const CaseContext = createContext<CaseContextType | null>(null);

export const useCaseContext = () => {
  const context = useContext(CaseContext);
  if (!context) {
    throw new Error('useCaseContext must be used within CaseProvider');
  }
  return context;
};
